export const messages = {
  en: {
    communityMini: {
      title: 'Community Mini Program',
      communityList: 'Community',
      page: {
        title: 'Community Mini Program',
        subtitle: 'Mini program configuration bound to each community',
        empty: 'No mini program configured for the current community',
        loadFailed: 'Failed to load mini program list, please retry',
        tip: 'The App Secret is masked for security; edit the record to view or update it'
      },
      name: 'Name',
      communityName: 'Community Name',
      appSecret: 'App Secret',
      description: 'Description',
      operation: 'Operation',
      add: 'Add',
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
      requiredName: 'Required, please fill in the name',
      requiredAppId: 'Required, please fill in APPID',
      requiredSecret: 'Required, please fill in App Secret',
      optionalDescription: 'Optional, please fill in description'
    }
  },
  zh: {
    communityMini: {
      title: '小区小程序',
      communityList: '小区选择',
      page: {
        title: '小区小程序',
        subtitle: '各小区绑定的小程序配置信息',
        empty: '当前小区尚未配置小程序',
        loadFailed: '小程序列表加载失败，请重试',
        tip: '应用密钥出于安全考虑已脱敏显示，修改记录时可查看与更新'
      },
      name: '名称',
      communityName: '小区名称',
      appSecret: '应用密钥',
      description: '描述',
      operation: '操作',
      add: '添加',
      edit: '修改',
      cancel: '取消',
      save: '保存',
      requiredName: '必填，请填写名称',
      requiredAppId: '必填，请填写APPID',
      requiredSecret: '必填，请填写应用密钥',
      optionalDescription: '选填，请填写描述信息'
    }
  }
}